export default __webpack_public_path__ + "static/media/bubble_nova_s3.92f7542e.png";